import { render, staticRenderFns } from "./HotelLicence.vue?vue&type=template&id=04d28c76&scoped=true&"
import script from "./HotelLicence.vue?vue&type=script&lang=js&"
export * from "./HotelLicence.vue?vue&type=script&lang=js&"
import style0 from "./HotelLicence.vue?vue&type=style&index=0&id=04d28c76&prod&lang=less&scoped=true&"
import style1 from "./HotelLicence.vue?vue&type=style&index=1&id=04d28c76&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d28c76",
  null
  
)

export default component.exports